// Basic swiper.js carousel - https://swiperjs.com/
if (document.querySelector(".image-carousel .swiper")) {
    let swiper = new Swiper('.image-carousel .swiper', {
        spaceBetween: 0,
        allowTouchMove: true,
        effect: 'crossfade',
        speed: 300,
        duration: 10000,

        // pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true,
        // },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        breakpoints: {
            700: {
            }
        }
    });
}



function init_hero_carousel() {
    const carousel = document.querySelector('.hero-carousel .swiper-container');
    if (!carousel) return;
    const wrapper = carousel.parentNode;
    const pagination = wrapper.parentNode.querySelector('.home-images__swiper-pagination');
    const swiper = new Swiper(carousel, {
        loop: true,
        effect: 'fade',
        speed: 800,
        duration: 20000,
        autoplay: {
            delay: 10000,
        },
        fadeEffect: {
            crossFade: true
        },

        autoHeight: false,

        // autoplay: {
        //     delay: 5000,
        // },

        // pagination: {
        // 	el: pagination,
        // 	type: 'bullets',
        // 	clickable: true,
        // },
        navigation: {
            el: '.swiper-nav',
            nextEl: '.swiper-nav .next',
            prevEl: '.swiper-nav .prev',
        },
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector(".hero-carousel .swiper-container")) {
        init_hero_carousel();
    }
});


function init_image_carousel() {
    const carousels = document.querySelectorAll('.image-carousel .swiper-container');
    console.log(carousels);
    if (!carousels) return;

    carousels.forEach(carousel => {
        const wrapper = carousel.parentNode;
        const pagination = wrapper.parentNode.querySelector('.home-images__swiper-pagination');
        const swiper = new Swiper(carousel, {
            loop: true,
            effect: 'slide',
            speed: 800,
            // autoplay: false,
            fadeEffect: {
                crossFade: true
            },

            autoHeight: false,

            duration: 800,
            // autoplay: {
            //     delay: 5000,
            // },

            // pagination: {
            // 	el: pagination,
            // 	type: 'bullets',
            // 	clickable: true,
            // },
            navigation: {
                el: '.swiper-nav',
                nextEl: '.swiper-nav .next',
                prevEl: '.swiper-nav .prev',
            },

            slidesPerView: 1,
            spaceBetween: 0,

            // Add media queries
            // breakpoints: {
            //     // when window width is >= 640px
            //     770: {
            //         slidesPerView: cards ? 3 : 1,
            //         spaceBetween: cards ? 18.5 : 0,
            //     }
            // }
        });
    } );
}


function init_image_carousel_cards() {
    console.log('init_image_carousel-c');
    const carousel = document.querySelector('.image-carousel-cards .swiper-container');
    if (!carousel) return;
    const wrapper = carousel.parentNode;
    // const pagination = wrapper.parentNode.querySelector('.home-images__swiper-pagination');
    const swiper = new Swiper(carousel, {
        loop: true,
        effect: 'slide',
        speed: 300,
        // autoplay: false,


        autoHeight: false,
        centeredSlides: true,

        // duration: 800,
        // autoplay: {
        //     delay: 5000,
        // },

        // pagination: {
        // 	el: pagination,
        // 	type: 'bullets',
        // 	clickable: true,
        // },
        navigation: {
            el: '.swiper-nav',
            nextEl: '.swiper-nav .next',
            prevEl: '.swiper-nav .prev',
        },

        // slidesPerView: 'auto',
        slidesPerView: 1,
        spaceBetween: 10,

        // Add media queries
        breakpoints: {
            // when window width is >= 640px
            600: {
                // slidesPerView:  2.3,
                slidesPerView:  'auto',
                spaceBetween: 18.5,
            }
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector(".image-carousel .swiper-container")) {
        init_image_carousel();
    }

    if (document.querySelector(".image-carousel-cards .swiper-container")) {
        init_image_carousel_cards();
    }
});

